<script setup lang="ts">
import type { ActivitiesRecord } from "@/utils/PocketBaseAdapter";

// interface
interface Props {
  isOpen: boolean;
  activity?: ActivitiesRecord;
  type?: string;
  isAdmin?: boolean;
}

// props
const props = defineProps<Props>();

// Emit
const emit = defineEmits<{
  (e: "closeDialog", val: boolean): void;
  (e: "cancelBooking", val: boolean): void;
  (e: "leavePending"): void;
}>();
</script>

<template>
  <VDialog :model-value="isOpen" persistent no-click-animation max-width="530">
    <VCard>
      <div class="d-flex align-center justify-space-between bg-error">
        <!-- 👉 Header -->
        <VCardTitle style="color: white;"> Cancel booking </VCardTitle>
        <VBtn
          icon="mdi-close"
          size="large"
          variant="text"
          class="rounded-0"
          color=""
          @click="emit('closeDialog', false)"
        ></VBtn>
      </div>
      <VCardText>
        <div class="mb-5">
          We are currently holding this booking for you, if you cancel now then
          the booking hold will be released. <br /><br />

          <span>
            Are you sure you want to cancel this
            <span v-if="type === 'Event'"> Event </span>
            <span v-if="type != 'Event' && props?.activity?.name"> {{props?.activity?.name}} </span>
            booking
          </span>

        </div>
      </VCardText>
      <VCardActions>
        <v-spacer></v-spacer>
        <VBtn
          v-if="props.isAdmin"
          color="secondary"
          variant="outlined"
          @click="emit('leavePending')"
          >Leave Pending</VBtn
        >
        <VBtn
          color="secondary"
          variant="outlined"
          @click="emit('closeDialog', false)"
          >No - Continue</VBtn
        >
        <VBtn
          color="error"
          variant="flat"
          text
          @click="emit('cancelBooking', true)"
          >Yes - Cancel booking</VBtn
        >
      </VCardActions>
    </VCard>
  </VDialog>
</template>
